<template>
  <div id="app">
    <!-- 路由出口 -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  beforeCreate() {
    let appId = localStorage.getItem("appId");
    this.$store.commit("setAppId", appId);

    let token = localStorage.getItem("token");
    this.$store.commit("setToken", token);

    if (appId && token) {
      console.log(this.$router);
      // this.$router.push({
      //   name: "home",
      // });
    }
  },
};
</script>

<style>
#app {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  width: 100%;
  height: 100vh;
}
.van-popup {
  background: none !important;
}

</style>
